import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useContextSystem } from '@wp-g2/context';
import { cx } from '@wp-g2/styles';
import { useText } from '../Text';
import * as styles from './Link.styles';
/**
 * @typedef OwnProps
 * @property {boolean} [isPlain]
 */

/** @typedef {OwnProps & import('../Text/types').Props} Props */

/**
 *
 * @param {import('@wp-g2/create-styles').ViewOwnProps<Props, 'a'>} props
 */

export function useLink(props) {
  var _useContextSystem = useContextSystem(props, 'Link'),
      className = _useContextSystem.className,
      isPlain = _useContextSystem.isPlain,
      otherProps = _objectWithoutProperties(_useContextSystem, ["className", "isPlain"]);

  var textProps = useText(otherProps);
  var classes = cx(textProps.className, [styles.BaseLink, !isPlain && styles.Link], className);
  return _objectSpread(_objectSpread({}, textProps), {}, {
    className: classes
  });
}